var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-information" }, [
    _c("p", { staticClass: "visually-hidden", attrs: { id: "tablist-1" } }, [
      _vm._v("\n    Product Information\n  ")
    ]),
    _vm._v(" "),
    !_vm.isMobile
      ? _c(
          "div",
          { staticClass: "product-information__tabs-container" },
          [
            _c(
              "div",
              {
                staticClass: "product-information__tabs",
                attrs: { role: "tablist", "aria-labelledby": "tablist-1" }
              },
              [
                _vm.tabs.description
                  ? _c(
                      "button",
                      {
                        staticClass: "product-information__tabs-item h6",
                        class: _vm.tabClasses(0),
                        attrs: {
                          type: "button",
                          role: "tab",
                          "aria-selected": _vm.tabIsSelected(0),
                          "aria-controls": "tabpanel-0"
                        },
                        on: {
                          click: function($event) {
                            return _vm.onTabClicked(0)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.tabs.description.title) +
                            "\n      "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.tabsWithContent, function(tab) {
                  return _c(
                    "button",
                    {
                      key: tab.index,
                      staticClass: "product-information__tabs-item h6",
                      class: _vm.tabClasses(tab.index),
                      attrs: {
                        type: "button",
                        role: "tab",
                        "aria-selected": _vm.tabIsSelected(tab.index),
                        "aria-controls": "tabpanel-" + tab.index
                      },
                      on: {
                        click: function($event) {
                          return _vm.onTabClicked(tab.index)
                        }
                      }
                    },
                    [_vm._v("\n        " + _vm._s(tab.title) + "\n      ")]
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "transition",
              {
                staticClass: "product-information__tabs-content",
                attrs: { name: "fade", mode: "out-in" }
              },
              [
                _c(
                  "div",
                  {
                    key: _vm.selectedTab,
                    staticClass: "product-information__tabs-content-wrapper"
                  },
                  [
                    _c("div", {
                      attrs: {
                        id: "tabpanel-" + _vm.selectedTab,
                        role: "tabpanel",
                        "aria-labelledby": "tab-" + _vm.selectedTab
                      },
                      domProps: { innerHTML: _vm._s(_vm.getContent) }
                    })
                  ]
                )
              ]
            )
          ],
          1
        )
      : _c(
          "div",
          [
            _vm.tabs.description
              ? _c(
                  "Accordion",
                  {
                    attrs: {
                      heading: _vm.tabs.description.title,
                      theme: "footer"
                    }
                  },
                  [
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(_vm.tabs.description.content)
                      }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.tabsWithContent, function(tab, index) {
              return _c(
                "Accordion",
                { key: index, attrs: { heading: tab.title, theme: "footer" } },
                [_c("div", { domProps: { innerHTML: _vm._s(tab.content) } })]
              )
            })
          ],
          2
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }